var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import moment from 'moment';
import { Exclude, Transform } from 'class-transformer';
import { QueryOperator } from '@logz-pkg/enums';
import { ApiTokenModel } from './api-token';
export class SharedTokenModel extends ApiTokenModel {
    filters = [];
    expirationDate;
    filtersOperator = QueryOperator.OR;
}
__decorate([
    Transform((filters) => filters.map(filter => filter.id), { toPlainOnly: true }),
    __metadata("design:type", Array)
], SharedTokenModel.prototype, "filters", void 0);
__decorate([
    Exclude(),
    __metadata("design:type", Object)
], SharedTokenModel.prototype, "createdAt", void 0);
__decorate([
    Transform((value) => (value ? value.valueOf() / 1_000 : null), { toPlainOnly: true }),
    Transform((value) => (value ? moment(value * 1_000) : null), { toClassOnly: true }),
    __metadata("design:type", Object)
], SharedTokenModel.prototype, "expirationDate", void 0);
//# sourceMappingURL=shared-token.js.map